import { ContentPage } from "./ContentPage";
import { PLATFORM } from "../../config/platform";

// Reusable content body — used both on the public page and the in-app
// (Settings → Contact Us) screen.
export const ContactBody = () => (
  <>
    <p>
      We'd love to hear from you. Reach out and our team will get back to you as
      soon as possible.
    </p>

    <h2>Email</h2>
    <p>
      General:{" "}
      <a href={`mailto:${PLATFORM.support.contactus_email}`}>
        {PLATFORM.support.contactus_email}
      </a>
      <br />
      Sales:{" "}
      <a href={`mailto:${PLATFORM.support.sales_email}`}>
        {PLATFORM.support.sales_email}
      </a>
      <br />
      Support:{" "}
      <a href={`mailto:${PLATFORM.support.support_email}`}>
        {PLATFORM.support.support_email}
      </a>
    </p>

    <h2>Phone</h2>
    <p>
      {PLATFORM.support.contact_country_code} {PLATFORM.support.contact_mobile_no}{" "}
      (Mon–Fri, 9am–6pm IST)
    </p>

    <h2>Office</h2>
    <p>
      {PLATFORM.platform_name}
      <br />
      Bengaluru, Karnataka, India
    </p>
  </>
);

export const Contact = ({ onBack }: { onBack: () => void }) => (
  <ContentPage title="Contact Us" onBack={onBack}>
    <ContactBody />
    <h2>Enterprise sales</h2>
    <p>
      Looking at the Enterprise plan? Use the “Contact sales” button on the
      Enterprise plan card on our home page and we'll reach out directly.
    </p>
  </ContentPage>
);

export default Contact;
